import Skeleton from 'react-loading-skeleton'
import { Card } from '@cmsgov/ds-medicare-gov'
import 'react-loading-skeleton/dist/skeleton.css'

import classes from './PlanCard.module.scss'

export const PlanCardSkeleton = () => {
  return (
    <Card
      className={`ds-u-padding--3 ds-u-display--flex ds-u-flex-direction--column ${classes.card}`}
    >
      <div className="ds-text-body--md">
        <Skeleton />
      </div>
      <div className="ds-text-body--lg ds-u-margin-bottom--0">
        <Skeleton />
      </div>
      <hr className="ds-u-border-bottom--1 my-u-width--full ds-u-margin-y--2" />
      <div className="my-u-flex-grow-1">
        <div className="ds-text-body--md">
          <Skeleton />
        </div>
      </div>
      <div className="ds-text-body--md">
        <Skeleton />
      </div>
    </Card>
  )
}
